<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId"  @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
                <el-form-item label="点位名称">
					<el-select v-model="filters.mn" filterable  multiple collapse-tags reserve-keyword  style="width:320px" >
						<el-option
							v-for="item in devices" :label="item.name" :value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="功能区" >
                    <el-select v-model="filters.functionalAreaId"  filterable>
                        <el-option
                            v-for="item in areaList"
                            :label="item.name"
                            :value="item.id" :key="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="daterange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
                    <my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border  highlight-current-row v-loading="listLoading" style="width: 100%;"   size="small" id="mytable">
			<el-table-column type="index" label="序号"  ></el-table-column>
            <el-table-column prop="functionalAreaName" label="功能区类型"    ></el-table-column>
            <el-table-column prop="devicecount" label="子站数量"    ></el-table-column>
            <el-table-column prop="dueDays" label="理论监测天数" ></el-table-column>
            <el-table-column prop="daySizeSum" label="实际监测天数" ></el-table-column>

            <el-table-column prop="n00004standard" label="昼间合格标准" ></el-table-column>
            <el-table-column prop="n00004sum" label="昼间超标数量" ></el-table-column>
            <el-table-column label="昼间统计" >
                <template slot-scope="scope">
                    <table-query-button   @select-type="showDetail(scope.$index, scope.row,'n00004')" btnCon="详情">  </table-query-button>
                </template>
            </el-table-column>
         
            <el-table-column prop="n00005standard" label="夜间合格标准" ></el-table-column>
            <el-table-column prop="n00005sum" label="夜间超标数量" ></el-table-column>
            <el-table-column label="夜间统计" >
                <template slot-scope="scope">
                    <table-query-button   @select-type="showDetail(scope.$index, scope.row,'n00005')" btnCon="详情">  </table-query-button>
                </template>
            </el-table-column>

            <el-table-column prop="countsum" label="总超标数量" ></el-table-column>

		</el-table>

        <el-dialog title="超标详情" :visible.sync="formVisible"  :append-to-body="true"  width="80%"  top="10vh" id="detailDialog"  :close-on-click-modal="false">
			<el-table :data="dataDetailList" border  highlight-current-row v-loading="listLoading" style="width: 100%;"  :height="tableHeight"  size="small" >
                <el-table-column type="index" label="序号" ></el-table-column>
				<el-table-column prop="deviceName" label="点位名称"  ></el-table-column>
                <el-table-column prop="time" label="时间"  ></el-table-column>
                <el-table-column prop="mn" label="设备编码"  ></el-table-column>
                <el-table-column prop="n00004" label="Ld(dB)"  v-if="chooseFactor=='ld'"></el-table-column>
                <!-- <el-table-column prop="n00004multiple" label="超标倍数"  ></el-table-column> -->
                <el-table-column prop="n00005" label="Ln(dB)"  v-if="chooseFactor=='ln'" ></el-table-column>
                <!-- <el-table-column prop="n00005multiple" label="超标倍数"  ></el-table-column> -->
			</el-table>
            <el-col :span="24" class="toolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" 
                :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
                </el-pagination>
            </el-col>
		</el-dialog>

	</section>
</template>

<script>
	import { getProjects,getExcessiveCount,getFunctionalAreaList,getDevicesByProjectId,getExcessiveDataDetail,exportExcessiveData} from '../../api/api';
	import {formatDate,formatDateDay} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
    import TableQueryButton from '../../components/myButton/TableQueryButton.vue'

	export default {
	components: { myButton,TableQueryButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
                    functionalAreaId:"",
                    mn:"",
					time:[]
				},
				listLoading: false,
				dataList:[],
                filtersNow:{},//用于详情查看
                dataDetailList:[ ],
                dataDetailData:[],
				projects:[],
                areaList:[],
                total: 0,
				page:1,
				pageSize:10,
                start: 0, // 处理前端分页数据保存
                end: 0, // 处理前端分页数据保存

                userId:sessionStorage.getItem('userId'),
                chartLine:null,
                formHeight:0,
                tableHeight:0,
                devices:[],
                formVisible:false,
                chooseFactor:''
			}
			
		},
		methods: {
            clickBtn(type){
				if(type=="query"){
					this.getExcessiveCount();
				}else if(type=="export"){
					this.exportData();
				}else if(type=="reset"){
					this.reset();
				}
			},
            SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				this.formHeight=hgt*0.8;
                this.tableHeight=this.formHeight-170;
                document.getElementById("detailDialog").getElementsByClassName("el-dialog")[0].style.height=this.formHeight+"px";
			},
            exportData(){
                require.ensure([], () => {
                    let tHeader1=['功能区类型','子站数量','理论监测天数','实际监测天数','昼间合格标准','昼间超标数量','夜间合格标准','夜间超标数量','总超标数量'];
                    const { export_json_to_excel } = require('vendor/Export2Excel');
                    const filterVal = ['functionalAreaName', 'devicecount', 'dueDays','daySizeSum','n00004standard','n00004sum','n00005standard','n00005sum','countsum'];  

                    var data=[];
                    data.push(this.formatJson(filterVal, this.dataList));

                    var sheetName=[];
                    sheetName.push('Sheet1');

                    export_json_to_excel(tHeader1,data, '超标数据',sheetName);
                }) 
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            }, 
            showDetail(i,row,fac){
                this.SetHeight();
                let para = this.filtersNow;
                para.functionalAreaId=row.functionalAreaId;
                para.factor=fac;
                this.formVisible=true;
                if(fac=="n00004"){
                    this.total=row.n00004sum;
                    this.chooseFactor="ld";
                }else if(fac =="n00005"){
                    this.total=row.n00005sum;
                    this.chooseFactor="ln";
                }
                this.getExcessiveDataDetail(para);
            },
            getExcessiveDataDetail(para){
                this.dataDetailList=[];
                this.dataDetailData=[];
                getExcessiveDataDetail(para).then((res) => { 
                    if(res.data.result==false){
                        this.$message({
                            message: "查询出错,请重试",
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.dataDetailData = res.data.data; 
                        this.dataDetailList = this.dataDetailData.slice(0, this.pageSize);
                        this.filtersNow=para;
                        this.start = 0;
                        this.end = this.pageSize;
                    }
                });
            },
            handleSizeChange(val) {
                const preTable = this.dataDetailData.slice(0, this.start);
                const LastTable = this.dataDetailData.slice(this.end);
                this.dataDetailData = preTable.concat(this.dataDetailList).concat(LastTable);
                this.pageSize = val;
                this.start = this.pageSize * (this.page - 1);
                this.end =
                    this.pageSize * (this.page - 1) +
                    this.pageSize;
                this.dataDetailList = this.dataDetailData.slice(
                    this.pageSize * (this.page - 1),
                    this.pageSize * (this.page - 1) +
                    this.pageSize
                );
            },
                //改变页码
            handleCurrentChange(val) {
                const preTable = this.dataDetailData.slice(0, this.start);
                const LastTable = this.dataDetailData.slice(this.end);
                this.dataDetailData = preTable.concat(this.dataDetailList).concat(LastTable);
                // 处理数据后分页
                this.page = val;
                this.start = this.pageSize * (this.page - 1);
                this.end =
                    this.pageSize * (this.page - 1) +
                    this.pageSize;
                this.dataDetailList = this.dataDetailData.slice(
                    this.pageSize * (this.page - 1),
                    this.pageSize * (this.page - 1) +
                    this.pageSize
                );
            },
            reset(){
                this.filters.projectId="";
                this.filters.functionalAreaId="";
                this.filters.mn="";
            },
            getFunctionalAreaList(){
                getFunctionalAreaList({}).then((res) => {
                    this.areaList = res.data.data;
                });
			},
            getExcessiveCount(){
                var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDateDay(this.filters.time[0]).split(" ")[0]+" 06:00:00";
					endtime=formatDateDay(this.filters.time[1]).split(" ")[0]+" 06:00:00";
                }
				let para = {
                    projectId:this.filters.projectId,
                    functionalAreaId:this.filters.functionalAreaId,
                    userId:this.userId,
					startDate: starttime,
                    endDate: endtime
				};
                if(this.filters.mn!=""){
                    para.mn=this.filters.mn.toString();
                }
                 if(para.startDate==""){
                    this.$message({
                        message: "请选择时间",
                        type: 'warn'
                    })
                    return;
                }
                if(para.userId==""||para.userId==undefined){
                    this.$message({
                        message: "用户已离线，请重新登录",
                        type: 'warn'
                    })
                    this.$router.push({ path: '/login' });
                    return;
                }
				this.listLoading = true;
                getExcessiveCount(para).then((res) => { 
                    this.listLoading = false;
                    if(res.data.result=="false"){
                        this.$message({
                            message: res.data.msg,
                            type: 'warn'
                        })
                        return;
                    }else{
                        this.dataList = res.data.data; 
                        this.filtersNow=para;
                    }
                });
            },
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
                        this.getExcessiveCount();
                        this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
                    this.filters.deviceId="";
				});
            },
			setTime(){
				var end = new Date();
				var start = new Date();
                start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
                this.getFunctionalAreaList();
			}
		},
		mounted() {
			this.setTime();
		},
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }
    #mytable{
        margin-bottom: 10px;
    }
</style>


// WEBPACK FOOTER //
// ExcessiveCount.vue?50548618